"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpeech = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var use_mount_1 = require("./use-mount");

var use_set_state_1 = require("./use-set-state");

var voices = utils_1.isBrowser && typeof window.speechSynthesis === 'object' ? window.speechSynthesis.getVoices() : [];

function useSpeech(text, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = use_set_state_1.useSetState({
    isPlaying: false,
    lang: options.lang || 'default',
    voice: options.voice || voices[0],
    rate: options.rate || 1,
    pitch: options.pitch || 1,
    volume: options.volume || 1
  }),
      state = _a[0],
      setState = _a[1];

  var uterranceRef = React.useRef(null);
  use_mount_1.useMount(function () {
    if (utils_1.isBrowser) {
      var utterance = new SpeechSynthesisUtterance(text);

      if (options.lang) {
        utterance.lang = options.lang;
      }

      if (options.voice) {
        utterance.voice = options.voice;
      }

      utterance.rate = options.rate || 1;
      utterance.pitch = options.pitch || 1;
      utterance.volume = options.volume || 1;

      utterance.onstart = function () {
        setState({
          isPlaying: true
        });
      };

      utterance.onresume = function () {
        setState({
          isPlaying: true
        });
      };

      utterance.onend = function () {
        setState({
          isPlaying: false
        });
      };

      utterance.onpause = function () {
        setState({
          isPlaying: false
        });
      };

      uterranceRef.current = utterance;
      window.speechSynthesis.speak(uterranceRef.current);
    }
  });
  return state;
}

exports.useSpeech = useSpeech;